module.exports = function (app, publicKey) {
  var imgsrc = app.keychain.returnIdenticon(publicKey);
  var name = app.keychain.returnIdentifierByPublicKey(publicKey, true);
  if (name == publicKey) {
    name = 'Anonymous User';
  }
  return "\n   <div class=\"saito-user-menu\" id=\"saito-user-menu\">\n     <h2 class=\"saito-modal-title\">\n      <div class=\"saito-user\">\n        <div class=\"saito-identicon-box\"><img class=\"saito-identicon\" src=\"".concat(imgsrc, "\"></div>\n        ").concat(name, "\n        <div class=\"saito-userline\">").concat(publicKey, "</div>\n      </div>\n     </h2>\n     <div class=\"saito-modal-content saito-menu-select-heavy\">\n     </div>\n   </div>\n  \n   ");
};